/* eslint-disable camelcase */
import visual from 'assets/images/technology/visual.png';
import technology1 from 'assets/images/technology/technology1.png';
import technology2_1 from 'assets/images/technology/technology2_1.png';
import technology2_2 from 'assets/images/technology/technology2_2.png';
import technology3 from 'assets/images/technology/technology3.png';
import aqdPerformance from 'assets/images/technology/farm-in-aqd-performance.png';
import incheonCertification from 'assets/images/technology/Incheon_certification.png';
import companyVideo from 'assets/images/technology/AeroQbit_Company_Introduction.mp4';

export const krTechnology = {
  title: `기술소개`,
  subTitle: `Technology`,
  video: companyVideo,
  subject1: `DEP 기반 공기청정기형\n악취 저감 시스템`,
  subject1Desc: `악취저감시스템`,
  subject1Img: technology1,
  visual,
  subject2: `축사 내부 공기 순환,\n악취 저감 시스템`,
  subject2Desc: `축사내부공기순환`,
  subject2_1Img: technology2_1,
  subject2Content: [
    {
      title: `1. 설치 위치 및 작동 방식`,
      desc: [
        `축사 내부 통로 (높이 조절 가능하며 통로가 없는 경우 격벽 설치)`,
        `정전압 분무 및 전기영동 흡착`,
        `분진, 암모니아, 황화수소 등 악취원의 전기영동 흡착`,
        `축사 내부 수평/수직 공기순환`,
      ],
    },
    { title: `2. 작동 범위`, desc: [`시간당 500CMH(m³/hour)`, `50평 ~ 100평 (4m 축사 천고 기준)`] },
    { title: `3. 작동 효과`, img: technology2_2 },
  ],
  subject3: `AeroQbit-A 성능 검증 성적서`,
  subject3Desc: `성능`,
  subject3Content: {
    title: `성능 지표 (희석 배수)`,
    desc: [`저감 장치 작동 이전 : 14,422배`, `저감 장치 작동 이후 : 2,080배`, `효율 : 85% 저감`],
    img: technology3,
  },
  subject4: `AeroQbit-D 성능 검증 성적서`,
  subject4Desc: `성능`,
  subject4Content: {
    performanceTitle: `제습 성능 그래프`,
    performanceDesc: [
      `제습기 작동 시 실내 습도가 현저히 감소하여 축사 내부 환경을 개선합니다.`,
      `소나기와 같은 외부 환경 변화로 습도가 급격히 상승할 때도 제습기가 효과적으로 작동하여 습도를 조절합니다.`,
    ],
    performanceImg: aqdPerformance,
    certificationImg: incheonCertification,
  },
};

export const enTechnology = {
  title: `기술소개`,
  subTitle: `Technology`,
  video: companyVideo,
  subject1: `DEP 기반 공기청정기형\n악취 저감 시스템`,
  subject1Desc: `악취저감시스템`,
  subject1Img: technology1,
  visual,
  subject2: `축사 내부 공기 순환,\n악취 저감 시스템`,
  subject2Desc: `축사내부공기순환`,
  subject2_1Img: technology2_1,
  subject2Content: [
    {
      title: `1. 설치 위치 및 작동 방식`,
      desc: [
        `축사 내부 통로 (높이 조절 가능하며 통로가 없는 경우 격벽 설치)`,
        `정전압 분무 및 전기영동 흡착`,
        `분진, 암모니아, 황화수소 등 악취원의 전기영동 흡착`,
        `축사 내부 수평/수직 공기순환`,
      ],
    },
    { title: `2. 작동 범위`, desc: [`시간당 500CMH(m³/hour)`, `50평 ~ 100평 (4m 축사 천고 기준)`] },
    { title: `3. 작동 효과`, img: technology2_2 },
  ],
  subject3: `AeroQbit-A 성능 검증 성적서`,
  subject3Desc: `성능`,
  subject3Content: {
    title: `성능 지표 (희석 배수)`,
    desc: [`저감 장치 작동 이전 : 14,422배`, `저감 장치 작동 이후 : 2,080배`, `효율 : 85% 저감`],
    img: technology3,
  },
  subject4: `AeroQbit-D 성능 검증 성적서`,
  subject4Desc: `성능`,
  subject4Content: {
    performanceTitle: `제습 성능 그래프`,
    performanceDesc: [
      `제습기 작동 시 실내 습도가 현저히 감소하여 축사 내부 환경을 개선합니다.`,
      `소나기와 같은 외부 환경 변화로 습도가 급격히 상승할 때도 제습기가 효과적으로 작동하여 습도를 조절합니다.`,
    ],
    performanceImg: aqdPerformance,
    certificationImg: incheonCertification,
  },
};
